<div *ngIf="dashboardConfig && dashboardConfig.enabled === true"
class="dashboard">
<eidos-dashboard [userDashboard]="true"></eidos-dashboard>
</div>
<div *ngIf="dashboardConfig == undefined" class="dashboard-loader"><mat-spinner style="margin:0 auto;"></mat-spinner></div>
<div *ngIf="showUndefinedDashboardInfo()" class="dashboard"><p class="welcome">No dashboard configured for current user.</p></div>